export const authRoute= {
    path:"office/auth/redirect",
    name:"auth",
    component:()=>import("../../pages/Auth.vue")
}